import * as React from 'react';
import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import ResourceCreationPanel from '../ResourceCreationPanel';
import { createExternalLink, closePanel, setValue } from '../../containers/ExternalLinkCreationPanel/actions';
import { Fields } from '../../containers/ExternalLinkCreationPanel/reducer';
import ValidationUtils from '../../utils/validation';

export interface ExternalLinkCreationPanelProps {
	isOpen: boolean;
	fields: Fields;
	errors: { [k: string]: string | null };
	dispatch: Dispatch<StoreState>;
}

const getError = (name: string, value: string): string | null => {
	let error: string | null = null;

	if (name === 'url') {
		if (value && !ValidationUtils.isValidUrl(value)) {
			error = 'error.invalid_url';
		}
	}

	return error;
};

const ExternalLinkCreationPanel = ({ isOpen, fields, errors, dispatch }: ExternalLinkCreationPanelProps) => {
	const fieldsConfig = {
		name: {
			value: fields.name,
			label: I18n.t('messages.description'),
		},
		url: {
			value: fields.url,
			label: I18n.t('messages.url'),
		},
	};

	const handleFieldChange = (name: string, value: string) => {
		const error = getError(name, value);
		dispatch(setValue(name, value, error));
	};

	return(
		<ResourceCreationPanel
			isOpen={isOpen}
			icon="iconset_uprez_ext_link"
			fields={fieldsConfig}
			errors={errors}
			onFieldChange={(name, value) => handleFieldChange(name, value)}
			onConfirm={({ name, url }) => dispatch(createExternalLink(name.value, url.value))}
			onCancel={() => dispatch(closePanel())}
		/>
	);
};

export default ExternalLinkCreationPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ExternalLinkCreationPanel/index.tsx